import { ViewBooking, ViewBookingStatusEnum } from "collins-js-sdk";
import { getTimeToNextQuarterHour } from "../../../../../utils/helpers";

type updateBookingType = {
  selectedBooking: ViewBooking;
  bookings: ViewBooking[];
  bookingPropsToSave: Partial<ViewBooking>;
};
type updateBookingReturnType = {
  updatedBooking: ViewBooking;
  updatedBookings: ViewBooking[];
};
export const updateBooking = ({
  selectedBooking,
  bookings,
  bookingPropsToSave
}: updateBookingType): updateBookingReturnType => {
  const updatedBooking = Object.assign(selectedBooking, {
    ...bookingPropsToSave
  });

  const updatedBookings = [...bookings];
  const index = updatedBookings.findIndex((b) => b.id === selectedBooking.id);
  updatedBookings[index] = updatedBooking;

  return { updatedBookings, updatedBooking };
};

export const getCheckInWaitlistProps = (selectedBooking: ViewBooking) => {
  if (!selectedBooking.waitlisted) {
    return {};
  }

  if (!selectedBooking.waitlistDetails?.area) {
    return {
      status: ViewBookingStatusEnum.Complete,
      time: getTimeToNextQuarterHour()
    };
  }

  return {
    status: ViewBookingStatusEnum.Complete,
    time: getTimeToNextQuarterHour(),
    assignedArea: selectedBooking.waitlistDetails.area,
    assignedAreas: [selectedBooking.waitlistDetails.area]
  };
};
